export const environment = {
  production: true,
  API_URL: 'https://cor-mgmt-api-canada-staging.explorai.co',
  GOOGLE_MAPS_API_KEY: 'AIzaSyAeHIgNKn-4mrYLe0da50Fd8cTJFyRVM6c',
}
